type ToastProps = {
  message: string | null;
};

export default function Toast({ message }: ToastProps) {
  if (!message) return null;
  return (
    <div className="fixed bottom-6 left-1/2 z-[100] -translate-x-1/2 px-4">
      <div className="flex items-center gap-2 rounded-full border border-background-200 bg-foreground-950 px-5 py-3 text-sm text-background-50 shadow-lg shadow-foreground-950/10">
        <i className="ri-information-line text-base text-accent-400"></i>
        <span className="whitespace-nowrap">{message}</span>
      </div>
    </div>
  );
}